//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/DesignSimulation.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[1,"AbsoluteValueOfStress",0,"Expression",0],[0,"DesignSpace",1,"DesignSimulation.DesignSpace",0],[0,"DisplacementLocation",1,"Point",0],[0,"DisplacementType",1,0],[0,"DisplacementVector",1,"Direction",0],[1,"FirstFlexibleFrequency",0,"Expression",0],[1,"Mass",0,"Expression",0],[1,"MaxDisplacement",0,"Expression",0],[1,"MaxFirstFlexFrequency",0,"Expression",0],[1,"MaxPercentOfStress",0,"Expression",0],[1,"MaximumMass",0,"Expression",0],[0,"MaximumStressType",1,0],[1,"MinFirstFlexFrequency",0,"Expression",0],[1,"MinimumMass",0,"Expression",0],[0,"Name",1,0],[1,"SelectFace",0,"ScCollector",0],[0,"Type",1,0],[0,"UserSetName",1,0]],[],[]];
SPLM.DesignSimulation.OptimizationConstraintBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DesignSimulation.OptimizationConstraintBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DesignSimulation.OptimizationConstraintBuilder.ConstraintType = Object.freeze({
    "MassTarget" : "MassTarget", "MinimumMassLimit" : "MinimumMassLimit", "MaximumMassLimit" : "MaximumMassLimit", "MaximumStressLimit" : "MaximumStressLimit", "MaximumDisplacementLimit" : "MaximumDisplacementLimit", "FirstFlexibleModeTarget" : "FirstFlexibleModeTarget", "MinimumFirstFlexibleModeLimit" : "MinimumFirstFlexibleModeLimit", "MaximumFirstFlexibleModeLimit" : "MaximumFirstFlexibleModeLimit"});

SPLM.DesignSimulation.OptimizationConstraintBuilder.MaximumStressOption = Object.freeze({
    "UltimateTensileStrength" : "UltimateTensileStrength", "Yield" : "Yield", "Absolute" : "Absolute"});

SPLM.DesignSimulation.OptimizationConstraintBuilder.DisplacementOption = Object.freeze({
    "AbsoluteMagnitude" : "AbsoluteMagnitude", "X" : "X", "Y" : "Y", "Z" : "Z", "AlongVector" : "AlongVector"});

export default SPLM;